import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {DateTimeFormatter} from "../../../utils/formatters";

class NewsLetterList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "NewsletterList"}
                {...props}
                filter={[{field: "parent", operator: "isnull"}]}
                view="list"
                columns={{
                    "id": {
                        header: 'Kód',
                        width: 1,
                        filterable,
                        sortable,
                    },
                    "name": {
                        header: 'Név',
                        width: 5,
                        filterable,
                        sortable
                    },
                    "send_scheduled_at": {
                        header: 'Küldés dátuma',
                        width: 2,
                        sortable
                    },
                    "created_by.name": {
                        header: 'Létrehozta',
                        width: 2,
                        sortable
                    },
                    "updated_by.name": {
                        header: 'Módosította',
                        width: 2,
                        sortable
                    },
                    "updated_at": {
                        header: 'Módosítás dátuma',
                        width: 2,
                        sortable,
                        renderer: DateTimeFormatter
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default NewsLetterList;
